import React from 'react';
import { Label } from 'core';

export { default as GenerateTaskUI } from './generate-task-ui/generate-task-ui';

const extractFileName = (url) => {
  try {
    const urlWithoutParams = url.split('?')[0];
    const parts = urlWithoutParams.split('/');
    const fileName = parts[parts.length - 1];
    const hasExtension = /\.(csv|pdf|zip|xlsx|xls|json|txt|xml)$/i.test(fileName);
    return hasExtension ? fileName : null;
  } catch {
    return null;
  }
};

export const displayData = (data) => {
  if (typeof data === 'boolean') {
    return String(data);
  }

  if (data === null || data === undefined || data === '') {
    return '';
  }

  if (typeof data === 'number') {
    return String(data);
  }

  if (typeof data === 'string') {
    if (data.includes('http')) {
      let label = data;

      if (data.includes('s3') && data.includes('input.csv')) {
        label = 'input.csv';
      } else {
        const fileName = extractFileName(data);
        if (fileName) {
          label = fileName;
        }
      }

      return (
        <Label component="a" type="action" fontWeight={400} href={data} target="_blank" rel="noopener noreferrer">
          {label}
        </Label>
      );
    }
    if (data === '1') {
      return 'true';
    }
    if (data === '0') {
      return 'false';
    }

    return data;
  }
  if (Array.isArray(data)) {
    return data.map((r, idx) => (
      <>
        {displayData(r)}
        <br key={idx} />
      </>
    ));
  }
  if (typeof data === 'object') {
    return <pre>{JSON.stringify(data, null, 2)}</pre>;
  }

  return data;
};

export const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch {
    return false;
  }
  return true;
};

export const getUserFriendlyStatus = (status) => {
  switch (status) {
    case 'SUCCESS':
      return 'Success';
    case 'FAILED':
      return 'Failed';
    case 'PARTIAL_SUCCESS':
      return 'Partial Success';
    case 'IN_PROGRESS':
      return 'In Progress';
    default:
      return 'Finished';
  }
};

export const cleanArgs = (inputData) => {
  if (inputData?.inputS3Url) {
    return { csv: inputData.inputS3Url };
  }

  let args = inputData?.arguments;
  if (isJson(args)) {
    args = JSON.parse(args);
  }

  if (args?.taskParams) {
    const cleanedArgs = Object.entries(args.taskParams).reduce((acc, [key, value]) => {
      if (key !== 's3Key' && key !== 'taskRunId' && value) {
        acc[key] = value;
      }

      return acc;
    }, {});
    return cleanedArgs;
  }

  if (args && Object.keys(args).length) {
    const cleanedArgs = Object.entries(args).reduce((acc, [key, value]) => {
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});
    return cleanedArgs;
  }
  return undefined;
};
